// import SupportTeam from '../../components/SupportTeam/SupportTeam';
import Connection from '../../components/Connection/Connection';
import Modal from '../../components/Modal/Modal';
import { useState } from 'react';
import PopUp from '../../components/PopUp/PopUp';
import { FormData } from '../../types/types';
import Button from '../../components/Button/Button';
import Address from '../../components/Address/Address';

const Contacts = () => {
  //   const [isModal, setIsModal] = useState(false);
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    // setIsModal(false);
  };
  const handleSubmit = (formData: FormData) => {
    console.log(formData);
    setIsOpen(false);
  };
  //   const openIsModal = () => {
  //     setIsModal(true);
  //   };

  return (
    <>
      <Connection
        openModal={openModal}
        //   openIsModal={openIsModal}
      />
      <Address />
      {/* {isRequestSent ? (
        <Modal
          isOpen={isRequestSent}
          onClose={() => setIsRequestSent(false)}
          className='popup thank-popup'
          title='Thank you!'
        >
          <p className='popup__text text-large '>
            Your request has been successfully sent.
          </p>
          <p className='popup__text text-large '>
            Our expert will contact you soon.
          </p>
          <Button
            className='popup__button'
            type='button'
            onClick={() => setIsRequestSent(false)}
          >
            Close
          </Button>
        </Modal>
      ) : (
        <Modal
          isOpen={isModal}
          onClose={closeModal}
          className='popup popup--support'
          titleColor='Contact '
          title='our support team'
        >
          <p className='popup__text text-large '>
            Our team is available online to assist you with any questions or
            concerns you may have.
          </p> */}
      {/* выбор формы с введением телефона */}
      {/* <PopUp
            className='form-popup'
            onSubmit={handleSubmit}
            setIsOpen={setIsOpen}
            setIsRequestSent={setIsRequestSent}
          /> */}
      {/* как в макете с переходом в чаи с выбранным  */}
      {/* <SupportTeam className='team' />
        </Modal>
      )} */}

      {isRequestSent ? (
        <Modal
          isOpen={isRequestSent}
          onClose={() => setIsRequestSent(false)}
          className='thank-popup popup'
          title='Thank you!'
        >
          <p className='popup__text text-large '>
            Your request has been successfully sent.
          </p>
          <p className='popup__text text-large '>
            Our expert will contact you soon.
          </p>
          <Button
            className='popup__button'
            type='button'
            onClick={() => setIsRequestSent(false)}
          >
            Close
          </Button>
        </Modal>
      ) : (
        <Modal
          isOpen={isOpen}
          onClose={closeModal}
          className='popup'
          title='Share your request with our sales team'
        >
          <PopUp
            className='form-popup'
            onSubmit={handleSubmit}
            setIsOpen={setIsOpen}
            setIsRequestSent={setIsRequestSent}
          />
        </Modal>
      )}
    </>
  );
};
export default Contacts;
